import { lazy } from 'react';

const MfDetail = lazy(() => import(/* webpackChunkName: "detail-mf" */ './MfDetail'));

const MfWithdraw = lazy(() => import(/* webpackChunkName: "mf-withdraw" */ './MfWithdraw'));

const MfDeposit = lazy(() => import(/* webpackChunkName: "mf-deposit" */ './MfDeposit/MfDeposit'));

export { MfDetail, MfWithdraw, MfDeposit };
